import Header from '../components/header/header'
import Footer from '../components/footer/footer'
import Equipment from '../components/navigater'
import styles from './marathon.rem.module.scss'
import Card from '../smartArticle/Card'

import { Fragment, useEffect } from 'react'
import Play from '../home/images/btn_play@2x.png'
import { useState } from 'react'
import equip1 from './images/marathon-equip-1.png'

import equip2 from './images/marathon-equip-2.png'

import equip3 from './images/marathon-equip-3.png'
import equip4 from './images/marathon-equip-4.png'
import equip5 from './images/marathon-equip-5.png'

import equip6 from './images/marathon-equip-6.png'
import equip7 from './images/marathon-equip-7.png'

import equip8 from './images/marathon-equip-8.png'
import equip9 from './images/marathon-equip-9.png'
import equip10 from './images/marathon-equip-10.png'

import equip11 from './images/marathon-equip-11.png'
import equip12 from './images/marathon-equip-12.png'
import poseter from './images/poster.png'

function Home() {
  const _path = [
    {
      title: 'Home',
      href: '/',
    },
    {
      title: 'AI Marathon Workstation',
      href: '',
    },
  ]

  const [videoList, setVideoList] = useState([])
  useEffect(() => {
    document.body.scrollTop = 0
    setVideoList([
      {
        poster: poseter,
        contro: false,
        id: 'marathon',
        src: 'https://www.xempowerusa.com/videos/workstation.mp4',
      },
    ])
  }, [])

  const functionList = [
    { id: 1, title: 'Timing & Camera & GPS' },
    { id: 2, title: 'Running Bibs & band' },
    { id: 3, title: 'APP' },
    { id: 4, title: 'Timing & Camera & SOS & GPS' },
    { id: 5, title: 'Timing & Camera & GPS' },
    { id: 6, title: 'Data & Live Streaming & Workstation' },
  ]

  return (
    <Fragment>
      <Header />
      <Equipment title='Equipment Solutions' path={_path} />
      <main className={styles.main}>
        <Card className={styles.card} list={videoList} type={'video'} />
        <div className={styles.pagetitle} style={{}}>
          Application Scenarios
        </div>
        <div className={styles.maincontainer}>
          <div className={styles.section}>
            {/* <div className={styles.sectionTitle}></div> */}
            <div className={styles.sectionContent}>
              <div>
                <img src={equip1} alt='' width={'100%'} />
              </div>
              <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                {functionList.map(item => {
                  return (
                    <div
                      key={item.id}
                      style={{
                        width: '50%',
                        display: 'flex',
                        alignItems: 'center',
                        marginTop: '40px',
                      }}
                    >
                      <span
                        style={{
                          width: '16px',
                          height: '16px',
                          background: '#99746E',
                          borderRadius: '6px 0 6px 0',
                          color: '#fff',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          fontSize: '10px',
                          fontWeight: 700,
                          marginRight: '20px',
                        }}
                      >
                        {item.id}
                      </span>
                      <span style={{ fontSize: '12px', color: '#99746E' }}>
                        {item.title}
                      </span>
                    </div>
                  )
                })}
              </div>
              <div style={{ marginTop: '24px' }}>
                <p>
                  In terms of marathon events, with the aim of creating a safer,
                  more efficient and personalized event experience for runners,
                  we have independently developed an AI marathon workstation for
                  marathon sports and events. This system and its equipment are
                  both the first of their kind worldwide. It is compatible with
                  core functions, such as Course Timing, AI Monitoring, AI
                  Anti-cheating, AI Short Videos, AI Live Streaming, and AI
                  Scheduling.
                </p>
                <p style={{ marginTop: '20px' }}>
                  This system, based on artificial intelligence (AI) and
                  biometric technology, enables unattended operation of on-site
                  workstation equipment. The on-site videos and data will be
                  live-streamed throughout, serving every runner. It has been
                  successfully applied in some marathon events in 2024 and
                  marathon events in 2025.
                </p>
              </div>
            </div>
          </div>
          <div className={styles.section}>
            <div className={styles.sectionTitle}>Product Features</div>
            <div className={styles.sectionContent}>
              <img src={equip2} alt='' width={'100%'} />
              <div className={styles.absolute}>
                <p>Event Management</p>
                <p>
                  <span className={styles.dot} />
                  Real-Time Monitoring
                </p>
                <p>
                  <span className={styles.dot} />
                  Traffic Analysis
                </p>
                <p>
                  <span className={styles.dot} />
                  Anti-Cheating
                </p>
              </div>
              <div className={`${styles.absolute} ${styles.absolute1}`}>
                <p>Event Services</p>
                <p>
                  <span className={styles.dot} />
                  Personal Short Videos
                </p>
                <p>
                  <span className={styles.dot} />
                  Event Live Broadcasts
                </p>
                <p>
                  <span className={styles.dot} />
                  Runner Status Query (Catcher System)
                </p>
              </div>
            </div>
          </div>
          <div className={styles.section}>
            <div className={styles.sectionTitle}>Product Features</div>
            <div className={`${styles.sectionContent} ${styles.allImg}`}>
              <img src={equip3} alt='' width={'100%'} />
              <img src={equip5} alt='' width={'100%'} />
              <img src={equip4} alt='' width={'100%'} />

              <img src={equip6} alt='' width={'100%'} />
              <img src={equip7} alt='' width={'100%'} />

              <img src={equip8} alt='' width={'100%'} />
              <img src={equip9} alt='' width={'100%'} />
              <img src={equip10} alt='' width={'100%'} />
            </div>
          </div>
        </div>

        <p className={styles.bottomTitle}>What Can Xempower Do?</p>
        <div className={styles.bottomBg}>
          <img src={equip11} alt='' width={'100%'} />
        </div>
      </main>
      <Footer />
    </Fragment>
  )
}

export default Home
